import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { TrendingUp as TrendingUpIcon } from '@mui/icons-material';

function SavingsStats({ avgSavingsAmount, avgSavingsPercentage }) {
  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" gutterBottom>Savings Overview</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <TrendingUpIcon color="success" sx={{ mr: 1, fontSize: 40 }} />
        <Box>
          <Typography variant="h4" fontWeight="bold" color="success.main">
            ${(avgSavingsAmount || 0).toLocaleString()}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Average savings per vehicle
          </Typography>
        </Box>
      </Box>
      <Typography variant="body1">
        Average discount:{' '}
        <strong>{(avgSavingsPercentage || 0).toFixed(1)}%</strong> below market value
      </Typography>
    </Paper>
  );
}

export default SavingsStats;
